const ShippingReturnsData = [
  {
    type: "shipping",
    title: "Shipping Policy",
    content: [
      {
        heading: "Processing Time",
        description:
          "Orders are processed within 1-2 business days. Orders placed on weekends or holidays will be processed the next business day.",
      },
      {
        heading: "Shipping Methods",
        description:
          "We offer standard, expedited, and overnight shipping options within the United States. Shipping fees vary depending on the method chosen.",
      },
      {
        heading: "Delivery Time",
        description:
          "Standard shipping typically takes 3-7 business days. Expedited shipping takes 2-3 business days. Overnight shipping is 1 business day.",
      },
      {
        heading: "International Shipping",
        description:
          "Yes! We ship to select countries worldwide. Shipping costs and delivery times vary depending on your location and customs regulations. Please check our shipping page for estimated delivery times and international shipping fees.",
      },
    ],
  },
  {
    type: "returns",
    title: "Return Policy",
    content: [
      {
        heading: "Return Window",
        description:
          "Items can be returned within 15 days of delivery. Returned items must be unused, in original packaging, and with tags attached.",
      },
      {
        heading: "Return Process",
        description:
          "To initiate a return, contact our support team at support@example.com to obtain a return authorization. Pack your item securely and send it to our returns center.",
      },
      {
        heading: "Refunds",
        description:
          "Once we receive and inspect your return, we will process your refund to the original payment method within 5-7 business days.",
      },
      {
        heading: "Non-Returnable Items",
        description:
          "Gift cards, personalized items, and used products cannot be returned or exchanged.",
      },
      {
        heading: "Damaged or Defective Items",
        description:
          "If an item arrives damaged or defective, please contact us immediately so we can provide a replacement or refund.",
      },
    ],
  },
];

export default ShippingReturnsData;
